import { keyframes, styled } from 'styled-components';
import { ReactComponent as Edit } from '../../assets/icons/edit.svg';
import { ReactComponent as Link } from '../../assets/icons/link.svg';
import { ReactComponent as AddPhoto } from '../../assets/icons/add-photo.svg';
import { ReactComponent as Chevron } from '../../assets/icons/chevron-left.svg';

export const Button = styled.button`
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  user-select: none;
  justify-content: center;

  min-width: 17rem;
  border: none;
  padding: 0rem 2rem;
  width: fit-content;
  height: 5rem;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  border-radius: 3rem;
  background: #6868ac;
  box-shadow: 0px 12px 24px -6px rgba(81, 81, 145, 0.46);

  color: #fff;
  text-align: center;
  font-family: 'Avenir-Medium';
  font-size: 2rem;
  letter-spacing: 0.1px;

  &:hover {
    background: ${({ disabled }) => (disabled ? null : '#484888')};
  }

  &:active {
    ${({ disabled }) =>
      disabled
        ? null
        : `
    box-shadow: 0px 2px 8px -5px rgb(128, 128, 128);
    transition: all 0.1s ease-in;
    transform: scale(0.95);
  `};
  }
  @media (max-width: 450px) {
    font-size: 16px;
    height: 45px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8rem;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 48.44rem;
`;
export const Subtitle = styled.span`
  font-family: 'Avenir-Medium';
  font-size: 2.2rem;
  letter-spacing: -0.178px;
`;

export const Products = styled.div`
  display: flex;
  flex-direction: row;

  gap: 4rem;
  flex-wrap: wrap;
`;
export const BackCIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: 0.5rem;
  position: absolute;
  right: 1rem;
  top: 1rem;
  font-size: 2rem;
  cursor: pointer;
  align-content: center;
  user-select: none;
  font-family: 'Avenir-Heavy';
  justify-content: center;
  padding-top: 0.15rem;
  display: flex;
  width: 3rem;
  height: 3rem;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
`;
export const BackContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: 0.5rem;
  font-size: 2rem;
  cursor: pointer;
  align-items: center;
  user-select: none;
  font-family: 'Avenir-Heavy';
  display: flex;
  color: #484888;
`;

export const StyledBackContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: 0.5rem;
  position: absolute;
  right: -1rem;
  top: -1rem;
  font-size: 2rem;
  cursor: pointer;
  align-content: center;
  user-select: none;
  font-family: 'Avenir-Heavy';
  justify-content: center;
  padding-top: 0.15rem;
  display: flex;
  width: 3rem;
  height: 3rem;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
`;

export const ProductContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 2rem;
  gap: 2rem;
`;

export const Product = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #484888;
  padding: 2rem;
  gap: 2rem;
  border-radius: 2rem;
  position: relative;
`;

export const Photos = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: ${props => (props.$edit ? 'wrap' : 'nowrap')};

  gap: 1rem;
  @media (max-width: 380px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const AddPhotoIcon = styled(AddPhoto)`
  cursor: pointer;
  width: 4rem;
  height: 4rem;
  path {
    fill: #484888;
  }
`;
export const AddPhotoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 10rem;
`;

export const PhotoRelative = styled.div`
  position: relative;
`;
export const DeletePhotoContainer = styled.div`
  min-width: 2rem;
  min-height: 2rem;
  max-width: 2rem;
  max-height: 2rem;
  border-radius: 50%;
  padding-bottom: 0.15rem;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.15);
  font-size: 1.4rem;
  font-family: 'Avenir-Medium';
  color: white;
  transition: all 0.2s ease-in-out;
  position: absolute;
  right: -0.5rem;
  top: -0.5rem;
  &:hover {
    color: red;
  }
`;
export const DisplayedPhoto = styled.img`
  max-width: 50rem;
  min-width: 50rem;
  border-radius: 20px;
  max-height: 50rem;
  min-height: 50rem;
  object-fit: cover;
`;
export const Photo = styled.img`
  width: 15rem;
  height: 15rem;
  object-fit: cover;
  border-radius: 20px;
`;

export const Label = styled.span`
  color: #484888;
  font-family: 'Avenir-Heavy';
  font-size: 1.6rem;
  letter-spacing: -0.178px;
  @media (max-width: 450px) {
    text-align: center;
  }
`;
export const Value = styled.span`
  color: #484888;
  font-family: 'Avenir-Medium';
  font-size: 1.6rem;
  letter-spacing: -0.178px;
  @media (max-width: 450px) {
    text-align: center;
  }
`;

export const LabelRow = styled.div`
  display: flex;
  flex-direction: ${props => (props.$column ? 'column' : 'row')};
  flex-wrap: wrap;
  align-items: ${props => (props.$column ? 'flex-start' : 'center')};
  margin-bottom: ${props => (props.$column ? '1rem' : '0rem')};
  gap: 0.5rem;
  max-width: 25rem;
  @media (max-width: 450px) {
    justify-content: center;
    flex-direction: column;
  }
`;
export const Textarea = styled.textarea`
  border: none;
  height: 3rem;
  user-select: none;
  width: 100%;
  max-width: 36rem;
  transition: 0.2s;
  outline: none;
  resize: none;
  min-height: 6rem;
  border-radius: 1.5rem;
  background: none;

  border: ${props => (props.$error ? '1px solid #FF9494' : '1px solid #8c8c8c')};

  color: rgba(69, 69, 132, 1);
  font-family: 'Avenir-Medium';
  padding: 1rem 2rem;
  font-size: 1.6rem;
  letter-spacing: -0.178px;

  &:active,
  &:hover,
  &:focus {
    border: 1px solid #484888;
    box-shadow: none;

    &::placeholder {
      color: #000;
    }
  }

  &:focus {
    background: white;
    box-shadow: inset 0px 0px 5px rgba(0, 0, 0, 0.5);
  }
  &::placeholder {
    color: #979797;
  }
  @media (max-width: 450px) {
    font-size: 14px;
    border-radius: 7.5px;
    height: 40px;
  }
`;

export const Input = styled.input`
  border: none;
  height: 3rem;
  user-select: none;
  width: 100%;
  max-width: 36rem;
  transition: 0.2s;
  outline: none;

  border-radius: 1.5rem;
  background: none;

  border: ${props => (props.$error ? '1px solid #FF9494' : '1px solid #8c8c8c')};

  color: rgba(69, 69, 132, 1);
  font-family: 'Avenir-Medium';
  padding: 2rem;
  font-size: 1.6rem;
  letter-spacing: -0.178px;

  &:active,
  &:hover,
  &:focus {
    border: 1px solid #484888;
    box-shadow: none;

    &::placeholder {
      color: #000;
    }
  }

  &:focus {
    background: white;
    box-shadow: inset 0px 0px 5px rgba(0, 0, 0, 0.5);
  }
  &::placeholder {
    color: #979797;
  }
  @media (max-width: 450px) {
    font-size: 14px;
    border-radius: 7.5px;
    height: 40px;
  }
`;
export const AvailableTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 2rem;
  cursor: pointer;
`;

export const AvailableText = styled.span`
  color: #484888;
  text-align: center;
  font-family: 'Avenir-Medium';
  font-size: 1.6rem;
  letter-spacing: -0.178px;
`;

export const ChevronLeft = styled(Chevron)`
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.$disabled ? 0.65 : 1)};
`;
export const ChevronRight = styled(Chevron)`
  transform: scale(-1);
  opacity: ${props => (props.$disabled ? 0.65 : 1)};
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
`;

export const Chevrons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: auto;
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;

  color: #fff;
  font-family: 'Avenir-Medium';
  font-size: 1.6rem;
  letter-spacing: -0.178px;

  border-radius: 1.5rem;
  background-color: #d42e2e;
  height: 4rem;
  width: 14rem;
  cursor: pointer;
  box-shadow: 0px 5px 10px #48488850;
  transition: all 0.3s ease-in-out;
`;
export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;
export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  cursor: pointer;
  color: #fff;
  font-family: 'Avenir-Medium';
  font-size: 1.6rem;
  letter-spacing: -0.178px;

  border-radius: 1.5rem;
  background-color: #484888;
  height: 4rem;
  width: 14rem;

  box-shadow: 0px 5px 10px #48488850;
  transition: all 0.3s ease-in-out;
`;

export const Relative = styled.div`
  position: relative;
`;

export const DropDownValue = styled.span`
  color: rgb(0, 0, 0);
  font-family: 'Avenir';
  font-size: 1.6rem;
  font-style: normal;
  user-select: none;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.178px;
`;

export const DropDown = styled.div`
  border-radius: 15px;
  border: 1px solid #484888;
  border-bottom-right-radius: ${props => (props.$open ? 0 : 15)};
  border-bottom-left-radius: ${props => (props.$open ? 0 : 15)};
  background: #fff;
  z-index: 1000;
  width: 307px;
  height: 4rem;

  transition: all 0.2s ease-in-out;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 0px 5px 0px 20px;
  color: #000;
  font-family: 'Avenir';
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 350;
  line-height: normal;
  letter-spacing: -0.178px;
`;

export const DropDownMenu = styled.div`
  border-radius: 15px;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  position: absolute;
  border: 1px solid #484888;
  border-top: unset;
  background: #fff;
  width: 307px;

  max-height: 307px;
  overflow: hidden;
  z-index: 2;
`;

export const StyledDropDownMenu = styled.div`
  width: 100%;
  max-height: 218px;
  height: 100%;
  padding: 10px 20px 10px 20px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
  z-index: 5;
`;

export const ChevronMenu = styled(Chevron)`
  transition: all 0.2s ease-in-out;
  transform: ${props => (props.$open ? 'rotate(90deg)' : 'rotate(-90deg)')};
`;

export const Attributes = styled(DropDownValue)`
  color: black;
  cursor: pointer;
  padding-left: 10px;
  border-radius: 10px;
  &:hover {
    background: #48488822;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
`;

export const PhotosWrapper = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  max-height: 50rem;
  overflow: auto;
  padding-right: 0.5rem;

  &&::-webkit-scrollbar-track {
    background: transparent;
  }

  &&::-webkit-scrollbar {
    width: 5px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #484888;
    border-radius: 10rem;
    cursor: ew-resize;
  }
`;

export const ProductWrapper = styled.div`
  display: flex;
  align-self: center;

  gap: 3rem;
  flex-direction: column;
`;
export const PhotosContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;
export const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 380px) {
    justify-content: center;
  }
`;
export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;

  width: 100%;
  @media (max-width: 380px) {
    flex-wrap: wrap;
  }
`;
export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: translateY(-0.5rem);
  }

  &:active {
    opacity: 0.55;
  }
`;

export const FooterText = styled.span`
  color: #484888;
  font-family: 'Avenir-Medium';
  font-size: 1.2rem;
  letter-spacing: -0.178px;
`;

export const EditIcon = styled(Edit)`
  path {
    fill: #484888;
  }
`;
export const LinkIcon = styled(Link)`
  path {
    fill: #484888;
  }
`;
